import i18n from 'i18next';
import { AdvancedFilters } from 'newelements/Sportsbook/layouts/advanced/__partials/AdvancedMainContent/__partials/AdvancedFilters/index';

export enum EAdvancedSportFilters {
  NOW_NEXT = '0',
  COMPETITIONS = '1',
  COUPONS = '2'
}

const FILTER_ITEMS = [
  {
    key: EAdvancedSportFilters.NOW_NEXT,
    title: i18n.t('sportsbook.nowAndNext')
  },
  {
    key: EAdvancedSportFilters.COMPETITIONS,
    title: i18n.t('sportsbook.competitions')
  },
  {
    key: EAdvancedSportFilters.COUPONS,
    title: i18n.t('sportsbook.coupons')
  }
];

const SPORT_FILTERS_QUERY_KEY = 'viewBy';

export const SportFilters = () => {
  return (
    <AdvancedFilters
      queryKey={SPORT_FILTERS_QUERY_KEY}
      filterItems={FILTER_ITEMS}
      className="sportFilters"
    />
  );
};
